<template>
<div>
    <!-- 悬浮按钮 -->
        <el-button type="primary" round class="appbtn" @click="showApp">打开APP，发现更多精彩</el-button>
        <!-- 标题 -->
        <div class="navbar">
            <van-image width="50" height="50" src="../../static/assets/img/icon.png" ></van-image>
            <div style="font-size:larger;margin-left: 5%;width: 62%;">塔兮App</div>
            <van-button type="info"  size="normal" @click="showApp">下载</van-button>
        </div>
        <!-- 内容 -->
        <div v-if="success==false">
            <van-empty image="error" :description=msg />
        </div>
        <div v-else>
            <!-- 媒体内容类 -->
                <!-- 图片类 -->
                <div v-if="data.fileType==1">
                <van-swipe :autoplay="3000" indicator-color="white">
                    <van-swipe-item v-for="(item,index) in data.contentMedias" :key=index>
                    <van-image :src=item.mediaUrl width="100%" height="250px" fit="contain"/>
                    </van-swipe-item>
                </van-swipe>
                </div>
                <!-- 视频类 -->
                <div v-if="data.fileType==0">
                    <div v-if="data.lockFlag==0">
                        <video controls="controls" width="100%" height="250px" :poster=data.coverUrl style="background-color: black;" autoplay="autoplay">
                            <source :src=data.contentMedias[0].mediaUrl type="video/mp4">
                        </video>
                    </div>
                    <div v-else>
                        <div>
                            <img :src=data.coverUrl width="100%" height="250px"/>
                        </div>
                    </div>
                </div>
            
            <!-- 详情 -->
            <div style="padding: 20px 10px;">
                <!-- 用户信息 -->
                <div class="user"> 
                    <el-avatar :size="50" :src=user.headUrl />
                    <div style="margin-left:10px">
                        <div>{{user.nickname}}</div>
                        <div class="txid">塔兮ID：{{user.username}}</div>
                    </div>
                </div>
                <!-- 内容描述 -->
                <div style="margin-top:10px" class="van-multi-ellipsis--l2">
                    {{data.details}}
                </div>
            </div>
        </div>

        <!-- 相关推荐 -->
        <div style="padding: 20px 10px;">
            <p style="color:gray;">相关推荐</p>
            <phone-recommend-list :recommends="recommends"></phone-recommend-list>
        </div>
</div>
     
    
</template>

<script>
import PhoneRecommendList from '../../content/PhoneRecommendList.vue'

export default {
    name:'PCShare',
    components:{PhoneRecommendList},
    props:{
        data:{
            type:Object,
            default(){
                return {}
            }
        },
        user:{
            type:Object,
            default(){
                return {}
            }
        },
        video:{
            type:String,
            default(){
                return ''
            }
        },
        deviceType:{
            type:String,
            default(){
                return ''
            }
        },
        msg:{
            type:String,
            default(){
                return ''
            }
        },
        success:{
            type:Boolean,
            default(){
                return false
            }
        },
        recommends:{
            type:[],
            default(){
                return []
            }
        }
    },
    methods:{

        showApp(){
            if (this.deviceType=='ios') {
                window.open('https://apps.apple.com/cn/app/%E5%A1%94%E5%85%AE-%E5%A8%B1%E4%B9%90%E7%94%9F%E6%B4%BB%E7%A7%80/id1413261158', '_bank');
            }else if (this.deviceType=='android'||deviceType=='tablet') {
                window.open('https://towerxi.com/download/tx.apk', '_bank');
            }else {
                Notify({ type: 'primary', message: '设备类型未知'});
            }

        },
    }
}
</script>

<style scoped> 
.navbar{
    display: flex;
    margin: 3%;
    align-items: center;

}
.appbtn{
    z-index: 0;
    position: fixed;
    bottom: 5%;
    left: 20%;
    width: 60%;
}

.txid{
    color: #939393;
    text-align:left;
}

.user{
    display: flex;
    justify-content: flex-start;
}

</style>


// WEBPACK FOOTER //
// src/components/common/share/PhoneShare.vue